import { ContainerModule } from 'inversify'
import TYPES from '../../config/inversify.types'
import { HistoryServiceImpl } from './history.service.impl'

export const HistoryModule = new ContainerModule((bind) => {
    bind(TYPES.HistoryService).to(HistoryServiceImpl).inSingletonScope()
})
